import { FormControl, FormGroup, InputLabel, TextField, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'

import { useTranslation } from 'react-i18next'
import InlineValidationError from '../Form/InlineValidationError'
import MunicipalitySelect from '../Form/MunicipalitySelect'
import { PossessorChangeSearchFormValues } from './MonitoringSearchSchema'
import { SearchProps } from './SearchForm'

export default function PossessorChangeSearch({
  control,
  errors,
  register,
}: SearchProps<PossessorChangeSearchFormValues>) {
  const { t } = useTranslation('common')
  return (
    <>
      <Typography variant="body1" data-qa="possessor-change-search-description">
        {t('monitoring.puppyMilling.possessorChange.searchDescription')}
      </Typography>
      <FormGroup sx={{ gap: 2 }}>
        <Typography variant="h2">{t('monitoring.professionalActivity.monitoringArea')}</Typography>
        <FormControl>
          <Controller
            name="municipalityCode"
            control={control}
            render={({ field }) => (
              <MunicipalitySelect
                field={field}
                error={!!errors.municipalityCode}
                errorContent={errors.municipalityCode?.message || ''}
              />
            )}
          />
        </FormControl>
      </FormGroup>

      <FormGroup sx={{ gap: 1, gridColumn: { xs: '100%', sm: '1 / span 1' } }}>
        <Typography variant="h2">
          {t('monitoring.puppyMilling.possessorChange.amountTitle')}
        </Typography>
        <Typography variant="body1" mb={2}>
          {t('monitoring.puppyMilling.possessorChange.amountBody')}
        </Typography>
        <FormControl>
          <InputLabel htmlFor={'minimumPossessorChangeCount'}>
            {t('monitoring.puppyMilling.possessorChange.amount')}
            <i aria-hidden={true}>*</i>
            <i className="visible-hidden">{t('registrationForm.field.required')}</i>
          </InputLabel>
          <TextField
            {...register('minimumPossessorChangeCount')}
            id="minimumPossessorChangeCount"
            error={!!errors.minimumPossessorChangeCount}
            inputProps={{
              type: 'text',
              inputMode: 'numeric',
              maxLength: 3,
            }}
            autoComplete={'off'}
            data-qa="minimumPossessorChangeCount"
            disabled={false}
          />
          {errors.minimumPossessorChangeCount && (
            <InlineValidationError
              content={errors.minimumPossessorChangeCount.message}
              data-qa="form-minimumPossessorChangeCount"
            />
          )}
        </FormControl>
      </FormGroup>
    </>
  )
}
